import { feesV2Client } from '../fees-client-v2'
import { Fees } from '@cinch-labs/logistics-fees-types'

export const getFees = async (): Promise<Fees> => {
  const { data } = await feesV2Client.get<Fees>('/fees')

  return data
}
